import type { ApiQuestion } from '../../../../internalTypes';
import type { ScaleColumn } from '../../../../types/shared';
import { mapAnswerLogic } from '../shared/mapAnswerLogic';
import { resolveSubQuestionText } from './resolveStatementText';

export function buildScaleColumns(question: ApiQuestion, language?: string): ScaleColumn[] {
  if (question.matrixColumnQuestions && question.matrixColumnQuestions.length > 0) {
    return question.matrixColumnQuestions
      .filter(sub => sub.id)
      .map(sub => {
        const label =
          (language && sub.translations?.[language]?.answerText) ||
          sub.answerText ||
          resolveSubQuestionText(sub, language);
        const answerLogic = mapAnswerLogic(sub.controlConfig?.displayLogic);
        return {
          id: sub.id!,
          label,
          ...(answerLogic ? { answerLogic } : {}),
        };
      });
  }

  return (question.answerDetails ?? [])
    .filter(a => !a.hidden && !a.additional?.isHintText)
    .map((a, i) => {
      const label = (language && a.translations?.[language]?.answerText) || a.answerText || '';
      const answerLogic = mapAnswerLogic(a.controlConfig?.displayLogic);
      return {
        id: a.id ?? `col_${i}`,
        label,
        ...(answerLogic ? { answerLogic } : {}),
      };
    });
}
